var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from "react-router-dom";
import * as VolumePromotionLevelFactory from '../../../classes/definitions/volumePromotionLevel/volumePromotionLevel';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import volumePromotionLevelSchema from "../../../schemas/volumePromotionLevelSchema";
import Input from '../../UI/Input/Input';
var VolumePromotionLevelForm = /** @class */ (function (_super) {
    __extends(VolumePromotionLevelForm, _super);
    function VolumePromotionLevelForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.staticPageId = '';
        _this.brandId = '';
        _this.state = {
            formConfig: _.cloneDeep(volumePromotionLevelSchema),
            formIsValid: false,
            discardPopupVisble: false,
        };
        _this.updateNumberFields = function () {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _this.setState({
                formConfig: updatedFormConfig,
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType, elType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            updatedFormElement.value = event.target.value;
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({ formConfig: updatedFormConfig, formIsValid: NotosService.checkFormValidity(updatedFormConfig) });
        };
        _this.setDataToForm = function () {
            var level = _this.props.level;
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'from_quantity.value', level === null || level === void 0 ? void 0 : level.FromQuantity);
            _.set(updatedFormConfig, 'from_quantity.touched', true);
            _.set(updatedFormConfig, 'from_quantity.valid', true);
            _.set(updatedFormConfig, 'to_quantity.value', level === null || level === void 0 ? void 0 : level.ToQuantity);
            _.set(updatedFormConfig, 'to_quantity.touched', true);
            _.set(updatedFormConfig, 'to_quantity.valid', true);
            _.set(updatedFormConfig, 'percent_adjustment.value', level === null || level === void 0 ? void 0 : level.PercentAdjustment);
            _.set(updatedFormConfig, 'percent_adjustment.touched', true);
            _.set(updatedFormConfig, 'percent_adjustment.valid', true);
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var submittedVolumePromotionLevel = VolumePromotionLevelFactory.createVolumePromotionLevel({
                from_quantity: _.get(formData, 'from_quantity.value', 0),
                to_quantity: _.get(formData, 'to_quantity.value', 0),
                percent_adjustment: _.get(formData, 'percent_adjustment.value', 0),
            });
            _this.props.onSubmit(submittedVolumePromotionLevel);
        };
        _this.toVolumePromotionLevels = function () {
            var volumePromotionId = _.get(_this.props, 'match.params.id', '-1');
            if (volumePromotionId !== "-1") {
                _this.props.history.push(AppRoutes.volumePromotionsLevels.path);
                _this.props.history.push(AppRoutes.volumePromotion.path + '/' + volumePromotionId + AppRoutes.volumePromotionsLevels.path);
            }
            else {
                _this.props.history.push(AppRoutes.volumePromotionsLevels.path);
            }
        };
        return _this;
    }
    VolumePromotionLevelForm.prototype.componentDidMount = function () {
        this.updateNumberFields();
        if (this.props.level) {
            this.setDataToForm();
        }
    };
    VolumePromotionLevelForm.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (prevProps.level !== this.props.level) {
            this.setDataToForm();
        }
    };
    VolumePromotionLevelForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key
                });
            }
        }
        // Building form inputs
        var form = (formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) { return _this.eventHandlers(event, formElement.id, 'onChange', formElement.config.elementType); }, blur: function (event) { return _this.eventHandlers(event, formElement.id, 'onBlur', formElement.config.elementType); } }));
        }));
        var actionBtns = React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toVolumePromotionLevels, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK"));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
            form,
            actionBtns));
    };
    return VolumePromotionLevelForm;
}(React.Component));
// @ts-ignore
export default withRouter(VolumePromotionLevelForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/AdjustmentLevels/AdjustmentLevelForm/VolumePromotionLevelForm.tsx
// module id = 514
// module chunks = 0